import $ from 'jquery/src/jquery';

$(document).ready(function($) {

    function processHash(hash) {
        let timeout = 0;
        var $element = $(hash);
        var hashValue = hash.substr(1);

        if ($element.length) {
            if ( $element.hasClass('accordion__item') ) {
                $element.find('.accordion__itemHeader:not(.ui-state-active)').trigger('click');
                timeout = 400;
            }

            setTimeout(function () {
                var elementOffset = $element.offset().top;
                var elementHeight = $element.outerHeight();
                var elementCenter = elementOffset + elementHeight/2;

                $('html, body').animate({
                    scrollTop: elementOffset - $('.siteHeader').outerHeight() - 27
                }, 'normal');
            }, timeout);
        }
    }

    $(document).on('click', 'a[href*=\\#]', function (e) {

        if ( $(this).hasClass('ui-tabs-anchor') )
            return false;

        var url = $(this).attr('href');
        var hash = url.substring(url.indexOf('#'));
        if (hash === '#') {
            return false;
        }
        if ($(hash).length) {
            e.preventDefault();
            processHash(hash);
        }
    });

    $(window).on("load", function () {
        if (location.hash) {
            processHash(location.hash);
        }
    });
});